import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=776d5382&scoped=true"
import script from "./LangSelect.vue?vue&type=script&lang=js"
export * from "./LangSelect.vue?vue&type=script&lang=js"
import style0 from "./LangSelect.vue?vue&type=style&index=0&id=776d5382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776d5382",
  null
  
)

export default component.exports